import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonBackgroundMode, ButtonSize, ButtonType, ButtonVerticalSize, IconSize } from '../../types';


@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconButtonComponent {
  @HostBinding('class.loading')
  @Input()
  loading: boolean;

  @Input()
  svgIconPath: string;

  @HostBinding('attr.type')
  @Input()
  type: ButtonType = 'primary';

  @HostBinding('class.disabled')
  @Input()
  disabled: boolean;

  @HostBinding('class.active')
  @Input()
  isActive: boolean;

  @HostBinding('attr.bg-mode')
  @Input()
  backgroundMode: ButtonBackgroundMode = 'light';

  @Input()
  size: ButtonSize = 'small';

  @Input()
  iconSize: IconSize;

  @Input()
  verticalSize: ButtonVerticalSize = 'medium';

  get loaderAppearance(): 'light' | 'dark' | 'blue' {
    if (this.type === 'primary') {
      return this.backgroundMode;
    }

    return 'dark';
  }

  @HostBinding('class')
  private get classes(): string {
    return `btn ${this.size} vs-${this.verticalSize}`;
  }

  @HostBinding('attr.role')
  private role = 'button';
}
